import styled from "styled-components";
import CarImage from "../../assets/images/car-background.png";

export const Inner = styled.div`
	display: flex;
	min-height: 200px;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;
	padding: 30px 10px;
`;

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
`;

export const BackgroundContainer = styled.div`
	background-image: url(${CarImage});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	${(props) =>
		props.isMobile
			? `
    height: 50vh;
  `
			: `
    height: 50vh;
  `}
	${(props) =>
		props.isMobile
			? `
    width: 100%;
  `
			: `
    width: 70%;
  `}
`;

export const LogoContainer = styled.div`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	gap: 20px;
	opacity: 0.5;
	width: 100%;
	overflow-y: auto;
`;
